import { AudienceAidesHub } from '../../../components/aides/AudienceAidesHub';
import { AIDES_PROFESSIONNELS } from '../../../config/aides-professionnels';

export default function ProfessionnelsAidesHubPage() {
  return (
    <AudienceAidesHub
      audienceId="professionnels"
      aides={AIDES_PROFESSIONNELS}
      heroEyebrow="Panorama 2026 · 6 leviers cumulables"
      heroHeadline="Vos aides locaux pro,"
      heroHeadlineAccent="cumulables et chiffrées."
      heroIntro="Primes CEE, Coup de pouce chauffage & clim, suramortissement fiscal, prêts Bpifrance climat — et deux leviers souvent oubliés sur la facture elle-même : l'optimisation du tarif d'acheminement (TURPE) et l'exonération CSPE. Six leviers cumulables pour vos locaux pro (commerces, cabinets, agences, ateliers, restaurants, hôtels indépendants)."
      primaryCta={{ label: 'Diagnostic CEE pro', href: '/professionnels/diagnostic-cee' }}
      secondaryCta={{ label: 'Calculer mes aides', href: '/professionnels/calculer-mes-aides' }}
      bullets={['Gratuit · sans inscription', 'Résultat indicatif immédiat', 'Sources réglementaires citées']}
      gridEyebrow="6 leviers cumulables"
      gridTitle="Les aides et économies disponibles pour vos locaux pro"
      ctaFinalTitle="Quelle aide pour votre activité ?"
      ctaFinalDescription="On identifie les fiches CEE BAT qui s'appliquent à vos travaux, on vérifie l'éligibilité au Coup de pouce CVC tertiaire et on regarde si le suramortissement art. 39 quinquies AA peut se cumuler."
    />
  );
}
